/* 创建了一个新的 JavaScript 文件。其主要功能是监听 swatch 的点击事件，
并从其 `dataset` 中读取上一步注入的图片数据，然后动态替换产品卡主图的 `src` 和 `srcset` 属性。 |
 **目的：** 提供客户端的交互逻辑。它负责响应使用者的操作，并执行最核心的图片切换功能，实现“即选即看”的视觉效果。 |*/
class ProductCardSwatches {
  constructor(swatchContainer) {
    this.container = swatchContainer;
    this.card = this.container.closest('.card-wrapper');
    this.swatchInputs = this.container.querySelectorAll('.swatch-input__input');
    this.productLink = this.card.querySelector('.card__heading a, .card__information a');
    this.mainImage = this.card.querySelector('.card__media img');

    this.swatchInputs.forEach(input => {
      input.addEventListener('click', this.handleSwatchChange.bind(this));
      input.addEventListener('mouseenter', this.handleSwatchHover.bind(this));
      input.addEventListener('mouseleave', this.handleSwatchLeave.bind(this));
    });
  }

  handleSwatchChange(event) {
    const selectedInput = event.currentTarget;
    const newProductUrl = selectedInput.dataset.productUrl;
    if (this.productLink && newProductUrl) {
      this.productLink.href = newProductUrl;
    }
    this.switchImage(selectedInput);
  }

  handleSwatchHover(event) {
    this.switchImage(event.currentTarget);
  }

  handleSwatchLeave(event) {
    const checkedInput = this.container.querySelector('.swatch-input__input:checked');
    if (checkedInput) {
      this.switchImage(checkedInput);
    }
  }

  switchImage(input) {
    if (!this.mainImage || !input.dataset.mediaSrc) return;
    this.mainImage.src = input.dataset.mediaSrc;
    this.mainImage.srcset = input.dataset.mediaSrcset || '';
    this.mainImage.style.opacity = '0';
    setTimeout(() => { this.mainImage.style.opacity = '1'; }, 50);
  }
}

// 初始化函数（支持首次加载 + section 动态加载）
function initProductCardSwatches(scope = document) {
  scope.querySelectorAll('[data-product-card-swatches]').forEach(container => {
    if (!container.dataset.swatchesInit) { // 防止重复绑定
      new ProductCardSwatches(container);
      container.dataset.swatchesInit = 'true';
    }
  });
}

// 页面首次加载
document.addEventListener('DOMContentLoaded', () => {
  initProductCardSwatches();
});

// Shopify section 动态加载时也执行
document.addEventListener('shopify:section:load', (event) => {
  initProductCardSwatches(event.target);
});
